import React, { Component } from 'react';
import classNames from 'classnames';
import MoVeInDesktopHeader from '../../../../../common/components/MoVeInDesktopHeader';
import MoVeInDesktopFooter from '../../../../../common/components/MoVeInDesktopFooter';
import WelcomeHero from '../WelcomeHero';
import InstallersSection from '../InstallersSection';
import AssistanceStrip from '../AssistanceStrip';

import './DesktopWelcome.css';

class DesktopWelcome extends Component {
  onContactusClick = () => {
    window.open('tel:800101222', '_blank');
    return null;
  };

  render() {
    const { dataCollection } = this.props;

    const cls = classNames({
      DesktopWelcome: true
    });

    return (
      <div className={cls}>
        <MoVeInDesktopHeader />
        <WelcomeHero onIdAdesioneSubmit={this.props.onIdAdesioneSubmit} />
        <InstallersSection dataCollection={dataCollection} />
        <AssistanceStrip onContactusClick={this.onContactusClick} onEmailClick={this.props.onEmailClick} />
        <MoVeInDesktopFooter />
      </div>
    );
  }
}

export default DesktopWelcome;
